import * as styles from "@assets/css/themes.module.css";
class ThemeController {
    /**
     * Change the theme, either to the target theme or to the opposite.
     * @param targetTheme the target theme. Either `light` or `dark`.
     */
    static change(targetTheme) {
        const body = document.body.classList;
        let theme;
        if (targetTheme === undefined) {
            if (body.contains(styles.light)) {
                theme = styles.dark;
                targetTheme = "dark";
            }
            else {
                theme = styles.light;
                targetTheme = "light";
            }
        }
        else {
            theme = styles[targetTheme];
        }
        body.remove(targetTheme === "light" ? styles.dark : styles.light);
        body.add(theme);
        localStorage.setItem("theme", targetTheme);
    }
    /**
     * Initialize Themes.
     * Either load theme to the value saved in localStorage,
     * or based on browser preferences.
     */
    static init() {
        const theme = localStorage.getItem("theme");
        if (theme === "light" || theme === "dark") {
            ThemeController.change(theme);
        }
        else {
            // Assign theme value based on system preferrences if not present in local storage. Acts as default
            if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
                ThemeController.change("dark");
            }
            else {
                ThemeController.change("light");
            }
        }
        // Add transition to body background-color
        setTimeout(() => {
            document.body.classList.add(styles.body_transition);
        }, 300);
    }
}
export default ThemeController;
